import { Routes } from '@angular/router';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { HomeComponent } from './features/home/home.component';
import { LoginComponent } from './features/login/login.component';
import { CallbackComponent } from './features/callback/callback.component';
import { AuthGuard } from './guard/auth-guard/auth.guard';
import { LoginGuard } from './core/guards/login.guard';
import { confirmacaoVagaRoutes } from './features/confirmacao-vaga/confirmacao-vaga.routes';
import { inscricaoRoutes } from './features/inscricao/inscricao.routes';
import { editaisRoutes } from './features/editais/editais.routes';
import { confirmacaoInteresseVagaRoutes } from './features/confirmacao-interesse-vaga/confirmacao-interesse-vaga.routes';
import { programasRoutes } from './features/programas/programas.routes';
import { documentosRoutes } from './features/documentos/documentos.routes';
import { usuariosRoutes } from './features/usuarios/usuarios.routes';
import { vagasRoutes } from './features/vagas/vagas.routes';
import { perfisRoutes } from './features/perfis/perfis.routes';
import { categoriasRoutes } from './features/categorias/categorias.routes';
import { perfisProfissionaisRoutes } from './features/perfis-profissionais/perfis-profissionais.routes';
import { recursoMunicipioRoutes } from './features/recurso-municipio/recurso-municipio.routes';
import { recursoProfissionalRoutes } from './features/recurso-profissional/recurso-profissional.routes';
import { solicitarRecursoMunicipioRoutes } from './features/solicitar-recurso-municipio/solicitar-recurso-municipio.routes';
import { resultadoInterposicaoRecursoMunicipioRoutes } from './features/resultado-interposicao-recurso-municipio/resultado-interposicao-recurso-municipio.routes';
import { solicitarRecursoProfissionalRoutes } from './features/solicitar-recurso-profissional/solicitar-recurso-profissional.routes';
import { resultadoInterposicaoRecursoProfissionalRoutes } from './features/resultado-interposicao-recurso-profissional/resultado-interposicao-recurso-profissional.routes';
import { parametrizacaoEditaisRoutes } from './features/parametrizacao-editais/parametrizacao-editais.routes';
import { parametrizacaoRanqueamentoRoutes } from './features/parametrizacao-ranqueamento/parametrizacao-ranqueamento.routes';
import { baremaRoutes } from './features/barema/barema.routes';
import { gerenciarBaremaRoutes } from './features/gerenciar-barema/gerenciar-barema.routes';
import { gestaoCicloRoutes } from './features/gestao-ciclo/gestao-ciclo.routes';
import { simulacaoRoutes } from './features/simulacao/simulacao.routes';
import { bancaAcoesAfirmativasRoutes } from './features/banca-acoes-afirmativas/banca-acoes-afirmativas.routes';
import { bancoRoutes } from './features/banco/banco.routes';
import { minhaInscricaoRoutes } from './features/minha-inscricao/minha-inscricao.routes';
import { analiseDocumentalRoutes } from './features/analise-documental/analise-documental.routes';
import { gestaoCandidatosRoutes } from './features/distribuicao-candidatos/gestao-candidatos.routes';
import { escolhaVagasRoutes } from './features/escolha-vagas/escolha-vagas.routes';
import { profissionalHomolRoutes } from './features/profissional-homol/profissional-homol.routes';
import { periodosHomologacaoRoutes } from './features/periodos-homologacao/periodos-homologacao.routes';
import { gerenciarHomologacaoRoutes } from './features/gerenciar-homologacao/gerenciar-homologacao.routes';
import { relatoriosRoutes } from './features/relatorios/relatorios.routes';
import {gestaoMaavRoutes} from './features/gestao-maav/gestao-maav.routes';
import {painelMaavRoutes} from './features/painel-participacao-maav/painel-maav.routes';
import { rmsRoutes } from './features/rms/rms.routes';
import { rmsLoteRoutes } from './features/rms-lote/rms-lote.routes';
import { relatorioRmsRoutes } from './features/relatorio-rms/relatorio-rms.routes';
import { desligamentoProfissionalRoutes } from './features/desligamento-profissional/desligamento-profissional.routes';
import { buscaMedicoIntercambistaRmsRoutes } from './features/busca-medico-intercambista-rms/busca-medico-intercambista-rms.routes';
import { declaracaoParticipacaoRoutes } from './features/declaracao-participacao/declaracao-participacao.routes';
import { validacaoDeclaracaoRoutes } from './features/validacao-declaracao/validacao-declaracao.routes';
import { ajudaCustosRoutes } from './features/ajuda-custos/ajuda-custos.routes';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'ouvidoria',
    loadComponent: () =>
      import('./features/ouvidoria-login/ouvidoria-login.component').then(
        (m) => m.OuvidoriaLoginComponent,
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
  },
  ...inscricaoRoutes,
  ...programasRoutes,
  ...documentosRoutes,
  ...usuariosRoutes,
  ...vagasRoutes,
  ...perfisRoutes,
  ...categoriasRoutes,
  ...perfisProfissionaisRoutes,
  ...recursoMunicipioRoutes,
  ...recursoProfissionalRoutes,
  ...solicitarRecursoMunicipioRoutes,
  ...resultadoInterposicaoRecursoMunicipioRoutes,
  ...solicitarRecursoProfissionalRoutes,
  ...resultadoInterposicaoRecursoProfissionalRoutes,
  ...parametrizacaoEditaisRoutes,
  ...parametrizacaoRanqueamentoRoutes,
  ...baremaRoutes,
  ...confirmacaoVagaRoutes,
  ...confirmacaoInteresseVagaRoutes,
  ...gerenciarBaremaRoutes,
  ...gestaoCicloRoutes,
  ...editaisRoutes,
  ...simulacaoRoutes,
  ...bancaAcoesAfirmativasRoutes,
  ...bancoRoutes,
  ...minhaInscricaoRoutes,
  ...analiseDocumentalRoutes,
  ...gestaoCandidatosRoutes,
  ...escolhaVagasRoutes,
  ...profissionalHomolRoutes,
  ...periodosHomologacaoRoutes,
  ...relatoriosRoutes,
  ...gestaoMaavRoutes,
  ...painelMaavRoutes,
  ...rmsRoutes,
  ...rmsLoteRoutes,
  ...relatorioRmsRoutes,
  ...desligamentoProfissionalRoutes,
  ...buscaMedicoIntercambistaRmsRoutes,
  ...validacaoDeclaracaoRoutes,
  ...declaracaoParticipacaoRoutes,
  ...ajudaCustosRoutes,
  ...gerenciarHomologacaoRoutes,
  {
    path: '**',
    component: NotFoundComponent,
  },
];
